var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_380_1585",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 81
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.423706,
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_380_1585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3334 55.7571L58.8334 32.2571L54.1668 27.5904L35.3334 46.4237L25.8334 36.9237L21.1667 41.5904L35.3334 55.7571ZM40.0001 73.7571C35.389 73.7571 31.0556 72.8815 27.0001 71.1304C22.9445 69.3815 19.4167 67.0071 16.4167 64.0071C13.4167 61.0071 11.0423 57.4793 9.29342 53.4237C7.5423 49.3682 6.66675 45.0348 6.66675 40.4237C6.66675 35.8126 7.5423 31.4793 9.29342 27.4237C11.0423 23.3682 13.4167 19.8404 16.4167 16.8404C19.4167 13.8404 22.9445 11.4648 27.0001 9.71373C31.0556 7.96484 35.389 7.09039 40.0001 7.09039C44.6112 7.09039 48.9445 7.96484 53.0001 9.71373C57.0556 11.4648 60.5834 13.8404 63.5834 16.8404C66.5834 19.8404 68.9579 23.3682 70.7067 27.4237C72.4579 31.4793 73.3334 35.8126 73.3334 40.4237C73.3334 45.0348 72.4579 49.3682 70.7067 53.4237C68.9579 57.4793 66.5834 61.0071 63.5834 64.0071C60.5834 67.0071 57.0556 69.3815 53.0001 71.1304C48.9445 72.8815 44.6112 73.7571 40.0001 73.7571ZM40.0001 67.0904C47.4445 67.0904 53.7501 64.5071 58.9167 59.3404C64.0834 54.1737 66.6668 47.8682 66.6668 40.4237C66.6668 32.9793 64.0834 26.6737 58.9167 21.5071C53.7501 16.3404 47.4445 13.7571 40.0001 13.7571C32.5556 13.7571 26.2501 16.3404 21.0834 21.5071C15.9167 26.6737 13.3334 32.9793 13.3334 40.4237C13.3334 47.8682 15.9167 54.1737 21.0834 59.3404C26.2501 64.5071 32.5556 67.0904 40.0001 67.0904Z",
    fill: "#26BFBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.3e3a54e00416aba4d463ae9f80217e09.svg";
export { ForwardRef as ReactComponent };